import { render, staticRenderFns } from "./SetPasswordCom.vue?vue&type=template&id=2aaa214b&scoped=true"
import script from "./SetPasswordCom.vue?vue&type=script&lang=js"
export * from "./SetPasswordCom.vue?vue&type=script&lang=js"
import style0 from "./SetPasswordCom.vue?vue&type=style&index=0&id=2aaa214b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaa214b",
  null
  
)

export default component.exports